<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-light">

      <div class="container">
          <a class="navbar-brand" href="." style="max-width: calc(100% - 80px);"><img src="logo.png" alt="Der PARTEI-O-Mat" style="width: 100%;"></a>

        <button type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"><span class="navbar-toggler-icon"></span></button>

          <div id="navbarSupportedContent" class="collapse navbar-collapse">
            <ul class="navbar-nav mr-auto"></ul>
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link" href="https://www.die-partei.de/">Die PARTEI</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://www.facebook.com/DiePARTEI">
                  <font-awesome-icon :icon="['fab', 'facebook']" :aria-label="'Facebook'"></font-awesome-icon>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://www.instagram.com/diepartei/">
                  <font-awesome-icon :icon="['fab', 'instagram']" :aria-label="'Instagram'"></font-awesome-icon>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://www.telegram.me/diepartei">
                  <font-awesome-icon :icon="['fab', 'telegram']" :aria-label="'Telegram'"></font-awesome-icon>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://www.twitter.com/DiePARTEI">
                  <font-awesome-icon icon="fa-brands fa-x-twitter" :aria-label="'X (ehemalig Twitter)'"/>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://www.tiktok.com/@diepartei">
                  <font-awesome-icon :icon="['fab', 'tiktok']" :aria-label="'TikTok'"></font-awesome-icon>
                </a>
              </li>
            </ul>
          </div>
      </div>
    </nav>

    <main class="py-4">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <MatApp />
          </div>
        </div>
      </div>
    </main>

    <footer class="footer py-4">
      <div class="container text-center">
        <span class="text-muted">Der <strong>PARTEI-O-Mat</strong> ist ein kostenloser Service von <a href="https://www.die-partei.de/" target="_blank">Die PARTEI</a> (<a href="https://www.die-partei.de/impressum/">Impressum</a> / <a href="https://www.die-partei.de/datenschutz/">Datenschutz</a>).</span>
      </div>
    </footer>
  </div>
</template>

<script>
import MatApp from './components/MatApp.vue'

export default {
  name: 'app',
  components: {
    MatApp
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  background-color: #f8fafc;
}

.navbar {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,.04);
}

/* vietnamese */
@font-face {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  src: local('Nunito Regular'), local('Nunito-Regular'), url(./fonts/nunito/nunito-vietnamese.woff2) format('woff2');
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  src: local('Nunito Regular'), local('Nunito-Regular'), url(./fonts/nunito/nunito-latin-ext.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  src: local('Nunito Regular'), local('Nunito-Regular'), url(./fonts/nunito/nunito-latin.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@charset "UTF-8";

@import'~bootstrap/dist/css/bootstrap.css';
</style>
